import { Ref } from 'vue';
import { FieldHtmlNameUtil, HekateDisplayForm } from 'www-shared';
import ExternalUtil from '../../../../ExternalUtil';
import CommonPreFilledProgressiveProfile from './CommonPreFilledProgressiveProfileDefinition';

export default class EventRegistrationProgressiveProfile extends CommonPreFilledProgressiveProfile {
  public realtimeBranchModifications({
    formDefinition,
  }: {
    formDefinition: Ref<HekateDisplayForm>;
  }): void {
    super.realtimeBranchModifications({ formDefinition });

    EventRegistrationProgressiveProfile.hideAndGrabHidden({ formDefinition });
  }

  private static hideAndGrabHidden({
    formDefinition,
  }: {
    formDefinition: Ref<HekateDisplayForm>;
  }): void {
    const eventNameField = ExternalUtil.findDisplayFieldOrThrow({ formDefinition, fieldName: FieldHtmlNameUtil.hiddenStaticField1 });
    const eventDateField = ExternalUtil.findDisplayFieldOrThrow({ formDefinition, fieldName: FieldHtmlNameUtil.hiddenStaticField2 });

    eventNameField.componentName = 'hidden-field';
    eventDateField.componentName = 'hidden-field';
  }
}
